<template>
<div>
    <v-card flat color="white" v-if="item">
        <v-layout align-center>
            <v-btn icon @click="showSubtask(item.parentTask)" v-if="item.parentTask">
                <v-icon>subdirectory_arrow_right</v-icon>
            </v-btn>

            <v-text-field v-on:blur="updateTask({id: item.id, name: item.name})" hide-details style="font-size:18px; font-weight: bold" class="mt-1 pt-2" placeholder="Title" solo flat v-model="item.name" color="black"></v-text-field>
            <v-spacer></v-spacer>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn :color="getStatusColor(item.status)" outline dark style="border-radius: 5px" v-on="on">
                        {{item.status}}
                        <v-icon class="ml-2" small :color="getStatusColor(item.status)">arrow_drop_down</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-tile v-for="(status, index) in statuses" :key="index" @click="item.status = status, statusChanged()">
                        <v-list-tile-title>{{ status }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <!-- <v-btn icon>
                <v-icon>attach_file</v-icon>
            </v-btn> -->
            <v-btn v-if="!item.id" color="black" style="border-radius: 5px" outline flat @click="createTask()">Submit</v-btn>
            <v-btn icon @click="$emit('close')">
                <v-icon>close</v-icon>
            </v-btn>
        </v-layout>
        <v-tabs v-model="tab">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab>Info</v-tab>
            <v-tab>Media</v-tab>
        </v-tabs>
        <v-card-text v-if="tab==0">
            <v-layout justify-center wrap>
                <v-flex xs12>
                    <v-layout justify-start>
                        <v-flex xs6>
                            <v-list dense>
                                <v-list-tile v-if="editLocation">
                                    <v-list-tile-content style="width:90%">
                                        <v-autocomplete ref="location" style="font-size: 12px;width:100%" clearable v-on:blur="$refs['location'].blur()" dense v-model="item.location" return-object :items="locations" item-text="locationDescription" item-value="id" :loading="isLoading" placeholder="Search for Location" :search-input.sync="searchLocation" color="black" hide-no-data hide-selected></v-autocomplete>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon @click="updateTask({id: item.id, locationId: item.location?item.location.id:null}), editLocation= false">
                                            <v-icon color="primary">check</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="editNetwork">
                                    <v-list-tile-content style="width:90%">
                                        <v-autocomplete ref="locationNetwork" style="font-size: 12px;width:100%" clearable v-on:blur="$refs['locationNetwork'].blur()" dense v-model="item.locationNetwork" return-object :items="locationNetworks" item-text="name" item-value="id" :loading="isLoading" placeholder="Search Networks" :search-input.sync="searchNetwork" color="black" hide-no-data hide-selected></v-autocomplete>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon @click="updateTask({id: item.id, locationNetworkId: item.locationNetwork?item.locationNetwork.id:null}), editNetwork= false">
                                            <v-icon color="primary">check</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="editNode">
                                    <v-list-tile-content style="width:90%">
                                        <v-autocomplete ref="locationNode" style="font-size: 12px;width:100%" clearable v-on:blur="$refs['locationNode'].blur()" dense v-model="item.locationNode" return-object :items="locationNodes" item-text="name" item-value="id" :loading="isLoading" placeholder="Search for Node" :search-input.sync="searchNode" color="black" hide-no-data hide-selected></v-autocomplete>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon @click="updateTask({id: item.id, locationNodeId: item.locationNode?item.locationNode.id:null}), editNode= false">
                                            <v-icon color="primary">check</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="editSwitchingCentre">
                                    <v-list-tile-content style="width:90%">
                                        <v-autocomplete ref="switchingCentre" style="font-size: 12px;width:100%" clearable v-on:blur="$refs['switchingCentre'].blur()" dense v-model="item.switchingCentre" return-object :items="switchingCentres" item-text="name" item-value="id" :loading="isLoading" placeholder="Search for Centre" :search-input.sync="searchSwitchingCentre" color="black" hide-no-data hide-selected></v-autocomplete>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon @click="updateTask({id: item.id, switchingCentreId: item.switchingCentre?item.switchingCentre.id:null}), editSwitchingCentre= false">
                                            <v-icon color="primary">check</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile :key="locationKey" v-else-if="!editLocation&&!editNetwork&&!editNode&&!editSwitchingCentre">
                                    <v-list-tile-action>
                                        <!-- <v-icon v-if="item.locationType == 'location'">location_on</v-icon>
                                        <v-icon v-else-if="item.locationType == 'network'">share</v-icon>
                                        <v-icon v-else-if="item.locationType == 'node'">device_hub</v-icon>
                                        <v-icon v-else-if="item.locationType == 'switchingCentre'">business</v-icon> -->

                                        <v-menu offset-y style="width: 80%">
                                            <template v-slot:activator="{ on }">
                                                <v-btn flat icon color="black" style="border-radius: 5px; width: 80%" v-on="on">
                                                    <v-icon v-if="item.locationType == 'location'">location_on</v-icon>
                                                    <v-icon v-else-if="item.locationType == 'network'">share</v-icon>
                                                    <v-icon v-else-if="item.locationType == 'node'">device_hub</v-icon>
                                                    <v-icon v-else-if="item.locationType == 'switchingCentre'">business</v-icon>
                                                    <v-icon class="ml-2" small>arrow_drop_down</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-tile v-for="(type, index) in locationTypes" :key="index" @click="item.locationType = type.value">
                                                    <v-list-tile-action>
                                                        <v-icon>{{type.icon}}</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>{{ type.name }}</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-list-tile-action>
                                    <v-list-tile-content :key="locationKey" v-if="item.locationType == 'location'">
                                        <v-list-tile-title style="font-size:12px">
                                            <span v-if="item.location">{{item.location.locationDescription}}</span>
                                            <span v-else>No attached location</span>
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size:12px" v-if="item.location&&item.locationNetwork">
                                            {{item.location.locationNetwork.name}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content :key="locationKey" v-if="item.locationType == 'network'">
                                        <v-list-tile-title style="font-size:12px">
                                            <span v-if="item.locationNetwork">{{item.locationNetwork.name}}</span>
                                            <span v-else>No attached Network</span>
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size:12px" v-if="item.locationNetwork&&item.locationNetwork.locationNode">
                                            {{item.locationNetwork.locationNode.name}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content :key="locationKey" v-if="item.locationType == 'node'">
                                        <v-list-tile-title style="font-size:12px">
                                            <span v-if="item.locationNode">{{item.locationNode.name}}</span>
                                            <span v-else>No attached Node</span>
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size:12px" v-if="item.locationNode && item.locationNode.switchingCentre">
                                            {{item.locationNode.switchingCentre.name}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content :key="locationKey" v-if="item.locationType == 'switchingCentre'">
                                        <v-list-tile-title style="font-size:12px">
                                            <span v-if="item.switchingCentre">{{item.switchingCentre.name}}</span>
                                            <span v-else>No attached Switching Centre</span>
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action :key="locationKey">
                                        <v-btn v-if="item.locationType == 'location'" small icon @click="editLocation = true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                        <v-btn v-if="item.locationType == 'network'" small icon @click="editNetwork = true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                        <v-btn v-if="item.locationType == 'node'" small icon @click="editNode = true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                        <v-btn v-if="item.locationType == 'switcingCentre'" small icon @click="editSwitchingCentre = true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>event</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size:14px">
                                            Due:
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="width: 200px">
                                        <span @click="taskDateModal=true" style="cursor: pointer; font-size: 14px">{{formatDate(item.dueDate)}}</span>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>schedule</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size:14px">
                                            Time:
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="width: 200px">
                                        <VueCtkDateTimePicker format="HH:mm" formatted="HH:mm" minuteInterval="5" style="font-size: 14px" label="Due Time" only-time v-model="item.dueTime" />
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-textarea rows="1" class="start" style="overflow-y: auto; max-height: 40vh; margin-top: 10px;border-radius: 5px; font-size: 12px;" solo flat auto-grow placeholder="Description" v-model="item.description" color="black" v-on:blur="updateTask({id: item.id, description: item.description})"></v-textarea>

                                <v-subheader style="background: #f0f0f0; margin-top: 5px">Forms <v-spacer></v-spacer>
                                    <v-btn small icon @click="addFormModal=true">
                                        <v-icon small class="mr-1">add</v-icon>
                                    </v-btn>
                                </v-subheader>
                                <v-list-tile v-for="(form, i) in item.taskForms" :key="i">
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 12px">
                                            {{form.form.name}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 12px">
                                            {{form.form.description}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <small style="color: black">
                                            {{calculateCompletedFields(form)}}/{{calculateFormFields(form)}}</small>
                                    </v-list-tile-action>

                                </v-list-tile>
                                <v-list-tile v-if="!item.taskForms || item.taskForms.length == 0">
                                    <v-list-tile-content>
                                        <v-list-tile-sub-title style="font-size: 12px">No Forms Attached</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <!-- <v-flex xs12 class="mx-1"> -->
                                <!-- <v-layout wrap>
                        <v-flex xs12>
                            <v-list subheader dense style="width: 100%" :key="subtaskList"> -->
                                <v-subheader style="width: 100%;background: #f0f0f0">Subtasks <v-spacer></v-spacer>
                                    <v-btn small icon @click="addSubTask()">
                                        <v-icon small>add</v-icon>
                                    </v-btn>
                                </v-subheader>
                                <draggable v-model="item.subtasks" :options='{group: "daySubtasks"}' @change="change">
                                    <v-list-tile style="border: 1px solid lightgrey; border-radius: 5px" v-for="subtask in item.subtasks" :key="subtask.index">
                                        <v-list-tile-action class="ml-0 pl-0">
                                            <v-layout>
                                                <v-flex>
                                                    <v-btn icon small>
                                                        <v-icon>drag_indicator</v-icon>
                                                    </v-btn>
                                                </v-flex>
                                                <v-flex>
                                                    <v-hover v-on="on">
                                                        <v-btn slot-scope="{ hover }" small icon @click="subtask.status=='Complete'?subtask.status='Pending':subtask.status='Complete',updateSubTask(subtask)">
                                                            <v-icon :color="subtask.status=='Complete'?'light-green':hover?'light-green':'grey'">check_circle_outline</v-icon>
                                                        </v-btn>
                                                    </v-hover>
                                                </v-flex>
                                            </v-layout>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-text-field :ref="'subtask_'+subtask.index" color="black" v-on:blur="updateSubTask(subtask)" v-model="subtask.name" flat solo class="ma-0 pa-0" hide-details style="font-size: 12px; width: 100%"></v-text-field>
                                        </v-list-tile-content>
                                        <v-list-tile-action style="width: 120px">
                                            <v-layout justify-end align-center style="width: 100%">
                                                <v-flex class="mx-0">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn v-on="on" small class="mx-0" icon @click="removeSubTask(subtask)">
                                                                <v-icon small>close</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Remove subtask</span>
                                                    </v-tooltip>

                                                </v-flex>
                                                <v-flex class="mr-1">

                                                    <v-menu :ref="'menu_'+subtask.index" :key="subtask.key" v-model="subtask.menu" :close-on-content-click="true" :nudge-right="40" lazy transition="scale-transition" offset-x full-width min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <div v-on="on">
                                                                <v-btn small icon class="dotted mx-0" v-if="!subtask.dueDate">
                                                                    <v-icon small>event</v-icon>

                                                                </v-btn>
                                                                <span v-else :style="{'font-size': '12px', cursor: 'pointer', 'font-weight': 'bold', color: isFuture(subtask.dueDate)?'black': 'red'}"> {{formatDateShort(subtask.dueDate)}}</span>
                                                            </div>

                                                            <!-- <v-btn v-on="on"  style="font-size: 12px" small class="dotted mx-0" v-else>
                                                                {{formatDateShort(subtask.dueDate)}}
                                                            </v-btn> -->
                                                        </template>
                                                        <v-date-picker v-model="subtask.dueDate" @change="subtask.key ++, updateSubTask({id: subtask.id, dueDate: subtask.dueDate})" no-title scrollable>
                                                        </v-date-picker>
                                                    </v-menu>

                                                </v-flex>
                                                <v-flex class="mx-1">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn @click="showSubtask(subtask)" v-on="on" small class="dotted " icon>
                                                                <v-icon small>person</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Unassigned</span>
                                                    </v-tooltip>
                                                </v-flex>
                                                <v-flex class="ml-2 mr-0">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn v-on="on" icon @click="showSubtask(subtask)">
                                                                <v-icon small>chat_bubble</v-icon>
                                                                <v-icon small>chevron_right</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Subtask's notes & comments</span>
                                                    </v-tooltip>
                                                </v-flex>

                                            </v-layout>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </draggable>
                                <v-list-tile v-if="!item.subtasks || item.subtasks.length == 0">
                                    <v-list-tile-content>
                                        <v-list-tile-sub-title style="font-size: 12px">No Subtasks</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <!-- </v-list>

                        </v-flex>
                    </v-layout> -->
                                <!-- <v-btn outline small style="border-radius: 5px" @click="addSubTask()">
                                    <v-icon class='mr-1' small>add</v-icon> Add Subtask
                                </v-btn> -->
                                <!-- </v-flex> -->

                            </v-list>

                        </v-flex>
                        <v-flex xs6>
                            <v-list>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>person</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size:14px">
                                            Assignee
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="width: 200px">
                                        <v-autocomplete @change="updateTask({id: item.id, assignedToId: item.assignedToId?item.assignedToId:null}), AssignedUserChange()" style="font-size:14px" ref="users" color="black" clearable v-on:blur="$refs['users'].blur()" :items="users" item-text="fullname" item-value="id" v-model="item.assignedToId"></v-autocomplete>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>groups</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size:14px">
                                            Assigned User Role
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="width: 200px">
                                        <v-autocomplete @change="updateTask({id: item.id, userRoleId: item.userRoleId?item.userRoleId:null})" style="font-size:14px" ref="userRole" color="black" clearable v-on:blur="$refs['userRole'].blur()" :items="userRoles" item-text="name" item-value="id" v-model="item.userRoleId"></v-autocomplete>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile v-if="!editCollaborators">
                                    <v-list-tile-action>
                                        <v-icon>group</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size:14px">
                                            Collaborators
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" @click="collaboratorModal=true" icon small>
                                                    <v-icon small>add</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edit Collaborators</span>
                                        </v-tooltip>

                                    </v-list-tile-action>

                                </v-list-tile>
                                <v-layout justify-start wrap :key="collaboratorKey" class='pb-2'>
                                    <v-flex xs1 v-for="collaborator in item.taskCollaborators" :key="collaborator.id">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">

                                                <v-avatar v-on="on" size="35px" color="blue" class="title white--text">
                                                    <span class="smallText">{{ collaborator.contact.name.charAt(0)
                              }}{{
                                collaborator.contact.surname.charAt(0)
                              }}</span>
                                                </v-avatar>

                                            </template>
                                            <span>{{ collaborator.contact.name
                              }} {{
                                collaborator.contact.surname
                              }}</span>
                                        </v-tooltip>
                                    </v-flex>

                                </v-layout>

                                <v-flex id="change" xs12 :key="taskChangeKey" style="overflow-y: auto; max-height: 40vh; border-top: 1px solid lightgrey">
                                    <v-layout v-for="change in changeLog" :key="change.id" justify-start align-center>
                                        <v-flex xs2 class="text-xs-left ml-1" style="width: 100%">
                                            <span style="color: black; font-size: 10px; font-weight: bold" v-if="change.contact &&!change.action">{{ change.contact.name }} {{change.contact.surname}}</span>
                                            <br v-if="change.contact &&!change.action" />

                                            <div style="width: 100%" v-else-if="change.commentedBy">
                                                <span style="color: black; font-size: 10px; font-weight: bold">{{ change.commentedBy.name }} {{change.commentedBy.surname}}</span>
                                                <br />
                                            </div>

                                            <span style="color: black; font-size: 8px" v-if="change.createdAt">{{ formatDateTime(change.createdAt) }}</span>
                                        </v-flex>
                                        <v-flex class='text-xs-left ml-1' xs10 v-if="change.action">
                                            <span :style="{'font-size': '10px', 'text-align': 'left', color: change.action.includes('Complete')?'green':'grey', 'font-weight': change.action.includes('Complete')?'bold': 'normal'}" v-html="change.contact.name + ' ' + change.contact.surname +' ' + change.action"></span>
                                        </v-flex>
                                        <v-flex xs10 v-else-if="change.type&&change.type.includes('image')" class="text-xs-left" atyle="text-align: left">
                                            <v-img class="text-xs-left" contain style="max-height: 150px" :src="change.image"></v-img>
                                        </v-flex>
                                        <v-flex xs10 v-else-if="change.type&&change.type != 'comment'" class="text-xs-left ml-1" style="text-align: left">
                                            <v-layout justify-start align-center>
                                                <v-btn icon @click="downloadFile(change)">
                                                    <v-icon>download</v-icon>
                                                </v-btn><span>{{change.name}}</span>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs10 v-else class='text-xs-left ml-1' style="text-align: left">
                                            <span style="font-size: 10px;">{{change.comment}}</span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                             <at-ta :members="users.map(x=>x.fullname)">
                                        <v-textarea append-icon="send" @click:append="addComment()" @click:prepend="$refs.fileUpload.click()" rows="1" auto-grow solo flat style="border-radius: 5px; font-size: 14px; border: 1px solid grey" placeholder="Post an update or ask a question..." v-model="comment"></v-textarea>
                         
                            
                                   </at-ta>

                                </v-flex>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-flex>

            </v-layout>
        </v-card-text>
        <v-card-text v-else-if="tab==1" style="width: 100%;" :key="documentKey">
            <v-layout wrap>
                <v-flex xs4 v-for="upload in taskDocuments" :key="upload.id">
                        <v-img @click="downloadFile(upload)" style="cursor: pointer" cover contain max-height="200px" :src="upload.image" />
                </v-flex>
                <v-flex xs12 class="mt-2">
                    <div style="width: 100%; height: 200px">
                        <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                            <div class="dropZone-info" @drag="onChange">
                                <span class="dropZone-title" style="font-size: 12px; cursor: pointer">Drop file or click to upload</span>
                            </div>
                            <input type="file" @change="onChange">
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>

    <v-dialog ref="dialog" v-model="taskDateModal" lazy full-width width="750px">
        <v-date-picker style="height: 350px" landscape full-width scrollable v-model="item.dueDate">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="taskDateModal=false, DueDateChanged()">OK</v-btn>
        </v-date-picker>
    </v-dialog>

    <v-dialog v-model="collaboratorModal" persistent width="400px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Collaborators</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="collaboratorModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text v-if="item.taskCollaborators">
                <v-layout wrap justify-start :key="collaboratorKey" v-if="item.taskCollaborators">
                    <v-chip close @input="removeCollaborator(collaborator)" v-for="collaborator in item.taskCollaborators" :key="collaborator.id">{{collaborator.contact.name}} {{collaborator.contact.surname}}</v-chip>
                </v-layout>
                <v-autocomplete ref="collaborator" dense clearable v-on:blur="$refs['collaborator'].blur()" :items="users.filter(x=>!item.taskCollaborators.map(y=>y.contactId).includes(x.id))" item-text="fullname" item-value="id" return-object @change="addCollaborator()" v-model="selectedCollaborator"></v-autocomplete>

            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="addFormModal" persistent width="1000px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Linked Forms</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="addFormModal = false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-data-table :items="forms" :headers="formHeaders" item-key="id" style="cursor: pointer">
                    <template v-slot:items="props">
                        <td class="text-xs-center" @click="addForm(props.item)">{{ props.item.name }}</td>
                        <td class="text-xs-center" @click="addForm(props.item)">{{ props.item.description }}</td>

                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import Api from "@/services/Api.js";
import dateformat from "dateformat";
import draggable from "vuedraggable";
import At from "vue-at";
import AtTa from "vue-at/dist/vue-at-textarea"; // for textarea
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
    props: ['item'],
    components: {
        draggable,
        VueCtkDateTimePicker,
        At,
        AtTa
    },
    data: () => ({
        addFormModal: false,
        comment: '',
        collaboratorKey: 0,
        collaboratorModal: false,
        documentKey: 0,
        dragging: false,
        editLocation: false,
        editNetwork: false,
        editNode: false,
        editSwitchingCentre: false,
        editCollaborators: false,
        forms: [],
        formKey: 0,
        formHeaders: [{
                text: "Name",
                align: "center",
                value: "name",
            },
            {
                text: "Description",
                align: "center",
                value: "description",
            },
        ],
        file: '',
        hover: false,
        locationTypes: [{
                name: 'Location',
                value: 'location',
                icon: 'location_on'
            },
            {
                name: 'Network',
                value: 'network',
                icon: 'share'
            },
            {
                name: 'Node',
                value: 'node',
                icon: 'device_hub'
            },
            {
                name: 'Switching Centre',
                value: 'switchingCentre',
                icon: 'business'
            },

        ],
        locations: [],
        locationNetworks: [],
        locationsNodes: [],
        switchingCentres: [],
        locationKey: 0,
        selectedCollaborator: null,
        statuses: ["Incomplete", "Pending", "In Progress", "Complete", "Canceled"],
        subtaskList: 0,
        taskChangeKey: 0,
        taskDateModal: false,
        uploadKey: 0,
        users: [],
        userRoles: [],
        isLoading: false,
        searchLocation: null,
        searchNetwork: null,
        searchNode: null,
        searchSwitchingCentre: null,
        tab: 0
    }),
    created() {
        this.fetchOrgContacts()
        this.fetchUserRoles()
        this.getForms()
    },
    mounted() {
        this.subtaskList++
        var container = this.$el.querySelector("#change");
        container.scrollTop = container.scrollHeight;
    },
    computed: {
        changeLog() {
            let result = []
            if (this.item.documents) {
                this.item.documents.forEach(x => {
                    x.image = `data:${x.type};base64,${x.base64}`
                });
                result = [...result, ...this.item.documents]
            }
            if (this.item.taskChanges) {
                result = [...result, ...this.item.taskChanges]
            }
            if (this.item.taskComments) {
                result = [...result, ...this.item.taskComments]
            }
            console.log(result)
            this.taskChangeKey++
            return result
        },
        taskDocuments(){
             let result = []
            if (this.item.documents) {
                this.item.documents.forEach(x => {
                    x.image = `data:${x.type};base64,${x.base64}`
                });
                result = [...result, ...this.item.documents]
            }
            this.uploadKey ++
            return result
        }
    },
    watch: {
        'item.locationType': {
            immediate: true,
            handler(val) {
                // this.item.locationId = null
                // this.item.location = null
                // this.item.locationNetworkId = null
                // this.item.locationNetwork = null
                // this.item.locationNodeId = null
                // this.item.locationNode = null
                // this.item.switchingCentreId = null
                // this.item.switchingCentre = null
                // this.editLocation = false
                // this.editNetwork = false
                // this.editNode = false
                // this.editSwitchingCentre = false

                if (this.item.id) {
                    // this.updateTask(this.item)
                }
                this.locationKey++
            }
        },
        'item.dueTime': {
            immediate: true,
            handler(val) {
                if (this.item.id)
                    this.updateTask({
                        id: this.item.id,
                        dueTime: this.item.dueTime
                    })
            }
        },
        searchLocation(val) {
            // Items have already been loaded
            // if (this.locations.length > 0) return

            // Items have already been requested
            if (this.isLoading) return

            this.isLoading = true

            // Lazily load input items
            Api().get('/Locations/elasticSearch', {
                params: {
                    search: val
                }
            }).then(res => {
                this.locations = res.data
            }).finally(() => (this.isLoading = false))
        },

        searchNetwork(val) {
            if (this.isLoading) return
            this.isLoading = true
            Api().get('/locationNetworks/elasticSearch', {
                params: {
                    search: val
                }
            }).then(res => {
                this.locationNetworks = res.data
            }).finally(() => (this.isLoading = false))
        },
        searchNode(val) {
            if (this.isLoading) return

            this.isLoading = true
            Api().get('/locationNodes/search', {
                params: {
                    search: val
                }
            }).then(res => {
                this.locationNodes = res.data
            }).finally(() => (this.isLoading = false))
        },
        searchSwitchingCentre(val) {
            if (this.isLoading) return

            this.isLoading = true
            Api().get('/switchingCentres/search', {
                params: {
                    search: val
                }
            }).then(res => {
                this.switchingCentres = res.data
            }).finally(() => (this.isLoading = false))
        }
    },
    methods: {
        async addCollaborator() {
            if (this.item.id) {
                let collaborator = await this.createCollaborator({
                    taskId: this.item.id,
                    contactId: this.selectedCollaborator.id
                })
                this.item.taskCollaborators.push(collaborator)
                this.selectedCollaborator = null
            } else {
                this.item.taskCollaborators.push({
                    contactId: this.selectedCollaborator.id,
                    contact: this.selectedCollaborator
                })
                this.selectedCollaborator = null

            }
            this.collaboratorKey++
        },
        async addComment() {
            //   if (this.internal == true) {
            //     this.mentioned = this.members.filter((x) => comment.includes(x));
            //     await this.mentioned.map((y) => {
            //       this.membersEmail.map((x) => {
            //         if (x.fullName === y) {
            //           this.emailAddressArray.push(x.email);
            //         }
            //       });
            //     });
            //   } else {
            //     if (this.ticketItem.createdBy.permissions == "FNO Operator") {
            //       this.emailAddressArray.push(this.ticketItem.createdBy.emailAddress);
            //     } else {
            //       this.customerEmailAddressArray.push(
            //         this.ticketItem.createdBy.emailAddress
            //       );
            //     }
            //   }
            Api()
                .post("/taskComment", {
                    taskId: this.item.id,
                    type: "comment",
                    commentedById: this.$store.state.user.id,
                    comment: this.comment,
                })
                .then((response) => {

                    this.item.taskComments.push({
                        commentedById: this.$store.state.user.id,
                        commentedBy: this.$store.state.user,
                        comment: response.data.comment,
                        type: response.data.type,
                        createdAt: response.data.createdAt,
                        id: response.data.id,
                    });
                    this.comment = ''
                    this.taskChangeKey++
                });
        },
        addForm(item){
            Api().post('/tasks/form', {formId: item.id, taskId: this.item.id}).then(res=>{
                res.data.form = item
                this.item.taskForms.push(res.data)
                 this.subtaskList++
                 this.addFormModal = false
            })
        },
        async addSubTask() {
            let index = 0
            if (this.item.subtasks.length > 0) {
                index = Math.max(...this.item.subtasks.map(x => x.index)) + 1;
                if ((index - 1) < this.item.subtasks.length) {
                    index = this.item.subtasks.length
                }
            }
            let obj = {
                index: index,
                parentTaskId: this.item.id ? this.item.id : null,
                name: null,
                assignedToId: null,
                dueDate: null,
                status: 'Pending',
                dueTime: null
            }
            if (this.item.id) {
                let task = await this.createSubTask(obj)
                this.item.subtasks.push(task)

            } else {
                this.item.subtasks.push(obj)
            }
            this.subtaskList++
            // setTimeout(()=>{
            //     console.log(this.$refs['subtask_'+index][0])
            // this.$refs['subtask_'+index][0].$el.focus()

            // }, 250)
            this.$nextTick(() => this.$nextTick(() => this.$refs['subtask_' + index][0].focus()))
        },
        AssignedUserChange() {
            if (this.item.id && this.item.assignedToId) {
                this.updateTask({
                    id: this.item.id,
                    assignedToId: this.item.assignedToId
                })
                let user = this.users.find(x => x.id == this.item.assignedToId)
                this.LogChange({
                    taskId: this.item.id,
                    contact: this.$store.state.user,
                    contactId: this.$store.state.user.id,
                    action: 'assigned the task to ' + user.fullname
                })
            }
        },
        calculateCompletedFields(form) {
            let result = 0
            if (form.formResponse) {
                result = form.formResponse.formResponseFields.filter(x => x.value).length
            }
            return result
        },
        calculateFormFields(form) {
            let result = form.form.formFields.length
            if (form.formResponse) {
                result = form.formResponse.formResponseFields.length
            }
            return result
        },
        DueDateChanged() {
            if (this.item.id) {
                this.updateTask({
                    id: this.item.id,
                    dueDate: this.item.dueDate
                })
                let description = 'changed the due date to ' + this.formatDateShort(this.item.dueDate)
                if (this.item.dueTime) {
                    description += (' ' + this.item.dueTime.split(':')[0] + ':' + this.item.dueTime.split(':')[1])
                }
                this.LogChange({
                    taskId: this.item.id,
                    contact: this.$store.state.user,
                    contactId: this.$store.state.user.id,
                    action: description
                })
            }
        },
        downloadFile(item) {
            const linkSource = `data:${item.type};base64,${item.base64}`;
            const downloadLink = document.createElement("a");
            const fileName = item.name;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        },
        async change(event) {
            this.item.subtasks.map((x, i) => {
                x.index = i
            })
            if (this.item.id)
                this.updateSubtaskIndices(this.item.subtasks)
            this.subtaskList++
        },
        async createCollaborator(obj) {
            let result = {}
            await Api().post('/tasks/subscribe/' + obj.taskId, obj).then(res => {
                result = res.data
            })
            return result
        },
        async createTaskForm(obj) {
            let result = {}
            await Api().post('/tasks/form', obj).then(res => {
                result = res.data
            })
            return result
        },
        createTask() {
            Api().post('/tasks', this.item).then(async res => {
                if (this.item.subtasks) {
                    this.item.subtasks.forEach(x => {
                        x.parentTaskId = res.data.id
                    })
                    this.updateSubtaskIndices(this.item.subtasks)
                }
                if (this.item.taskCollaborators) {
                    this.item.taskCollaborators.forEach(x => {
                        x.taskId = res.data.id
                    })
                    for (let i = 0; i < this.item.taskCollaborators.length; i++) {
                        await this.createCollaborator(this.item.taskCollaborators[i])
                    }
                }

                if (this.item.taskForms) {
                    this.item.taskForms.forEach(x => {
                        x.taskId = res.data.id
                    })
                    for (let i = 0; i < this.item.taskForms.length; i++) {
                        await this.createTaskForm(this.item.taskForms[i])
                    }
                }
                this.item = {}
                this.$emit('taskCreated')
            })
        },
        async createSubTask(task) {
            let result = {}
            await Api().post('/tasks', task).then(res => {
                result = res.data
            })
            return result
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "dd mmm, yyyy");
            } else {
                null;
            }
        },
        formatDateShort(date) {
            date = new Date(date)
            if (date !== null) {
                return dateformat(date, "dd mmm");
            } else {
                null;
            }
        },
        formatDateTime(date) {
            date = new Date(date)
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd HH:MM");
            } else {
                null;
            }
        },
        fetchOrgContacts() {
            this.organisationUsers = [];
            Api()
                .get("/organisationContact")
                .then(async (response) => {
                    this.users = response.data.map((x) => x.contact).map(x => ({
                        id: x.id,
                        fullname: x.name + ' ' + x.surname,
                        name: x.name,
                        surname: x.surname,
                        email: x.email,
                        mobileNumber: x.mobileNumber
                    }))
                });

        },
getForms() {
            Api().get('/forms').then(res => {
                this.forms = res.data
            })
        },
        fetchUserRoles() {
            Api()
                .get('/userRole')
                .then(response => {
                    this.userRoles = response.data
                })
        },

        getStatusColor(status) {
            switch (status) {
                case 'Complete':
                    return '#119c36'
                case 'Incomplete':
                    return 'red'
                case 'Pending':
                    return 'orange'
                case 'In Progress':
                    return 'blue'
                case 'Canceled':
                    return 'red'
                default:
                    return 'grey'
            }
        },
        isFuture(date) {
            let today = new Date()
            today.setHours(0, 0, 0, 0)
            return new Date(date) >= today
        },
        LogChange(item) {
            Api().post('/tasks/change', item).then(res => {
                item.id = res.data.id
                item.createdAt = res.data.createdAt
                this.item.taskChanges.push(item)
                this.taskChangeKey++
            })
        },
        onChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                this.dragging = false;
                return;
            }
            this.createFile(files[0]);
        },
        async createFile(file) {
            // if (!file.type.match('text.*')) {
            //     alert('please select txt file');
            //     this.dragging = false;
            //     return;
            // }

            if (file.size > 5000000) {
                alert('please check file size no over 5 MB.')
                this.dragging = false;
                return;
            }

            this.file = file;
            var reader = new FileReader();
            await reader.readAsBinaryString(this.file);
            reader.onload = () => {
                file = btoa(reader.result)
                this.file.base64 = file;
                this.uploadDocument(this.file)
            }

            this.dragging = false;
        },
        removeCollaborator(collaborator) {
            let index = this.item.taskCollaborators.indexOf(collaborator)
            this.item.taskCollaborators.splice(index, 1)
            Api().put('/tasks/unsubscribe/' + collaborator.id, {
                isActive: false,
                isDeleted: true
            })
            this.collaboratorKey++
        },
        removeSubTask(subtask) {
            if (subtask.id) {
                this.updateSubTask({
                    id: subtask.id,
                    isActive: false,
                    isDeleted: false
                })
            }
            let index = this.item.subtasks.indexOf(subtask)
            this.item.subtasks.splice(index, 1)
            this.subtaskList++

        },
        async showSubtask(task) {
            console.log(task)
            this.$emit('showSubtask', task)
        },
        statusChanged() {
            if (this.item.id) {
                this.updateTask({
                    id: this.item.id,
                    status: this.item.status
                })
                this.LogChange({
                    taskId: this.item.id,
                    contact: this.$store.state.user,
                    contactId: this.$store.state.user.id,
                    action: 'changed the status to ' + this.item.status
                })
            }
        },
        uploadDocument(file) {
            if (this.item.id) {
                this.file = {
                    taskId: this.item.id,
                    name: file.name,
                    base64: file.base64,
                    type: file.type,
                    contactId: this.$store.state.user.id,
                    contact: this.$store.state.user,
                    isActive: true,
                    isDeleted: false,
                }
                Api()
                    .post('/upload', this.file).then(async response => {
                        this.file.id = response.data.id
                        this.file.createdAt = response.data.createdAt
                        this.item.documents.push(this.file)
                        this.file = ''
                        this.documentKey++
                        // this.documents = await this.fetchTicketDocuments(this.$route.params.ticketId)
                    })
            } else {
                this.file = {
                    taskId: this.item.id,
                    name: file.name,
                    base64: file.base64,
                    type: file.type,
                    contactId: this.$store.state.user.id,
                    contact: this.$store.state.user,
                    createdAt: new Date(),
                    isActive: true,
                    isDeleted: false,
                }
                this.item.documents.push(this.file)
                this.documentKey++
                this.file = ''
            }
            this.taskChangeKey++

        },
        updateTask(task) {
            if (task.id)
                Api().put('/tasks/' + task.id, task)
        },
        updateSubTask(subtask) {
            if (subtask.id)
                Api().put('/tasks/' + subtask.id, subtask)
        },
        updateSubtaskIndices(subtasks) {
            Api().post('/tasks/subtasks', subtasks)
        }
    }

}
</script>
// ::v-deep .v-input--is-focused .v-input__slot {
//     border-style: none !important;
// }

// // ::v-deep .v-input__slot::before  { border: 2px solid none !important;padding: 10px; border-radius: 5px;}
// ::v-deep .v-input__slot {
//     border: none !important;
// }
<style scoped>


.v-input__slot::before {
    border-style: none !important;
}

.some-style>>>.v-input__slot::before {
    border-style: none !important;
}

.dotted {

    border-style: dotted;
}

.dropZone {
    width: 100%;
    height: 90%;
    position: relative;
    border: 2px dashed rgb(138, 138, 138);
}

.dropZone:hover {
    border: 2px dashed #2e94c4;
}

.dropZone:hover .dropZone-title {
    color: #1975A0;
}

.dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

.dropZone-title {
    color: #787878;
}

.dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
}

.dropZone-over {
    background: #5C5C5C;
    opacity: 0.8;
}

.dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

</style>

// .hover>>>.theme--light.v-text-field > .v-input__control > .v-input__slot {
//     background: #ffffff;
//     border: 1px solid rgba(0, 0, 0, 0.38);
//     border-bottom-left-radius: 4px;
//     border-bottom-right-radius: 4px;

//     &:before {
//         display: none;
//     }
// }
// // .theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover{
// // border-width: 1px;
// // border-style: solid;
// // border-color: #6fbd44;
// // }
// .start{ border: 1px solid transparent !important; border-radius: 5px;margin: 10px;}